import { useQueryClient } from "@tanstack/react-query"
import { useCallback } from "react"
import { queryKeys } from "../../lib/query-keys"

export function useJournalCacheInvalidator(propertyId: string | undefined) {
	const queryClient = useQueryClient()
	return useCallback(() => {
		if (!propertyId) return
		queryClient.invalidateQueries({
			queryKey: queryKeys.propertyJournal(propertyId),
		})
	}, [queryClient, propertyId])
}
